import { Component, OnInit, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { AzureFunctionsService, Status, Subscription } from 'src/app/azurefunctions/azure-functions.service';
import { BaseAutorizeComponent } from '../shared/base-authorize.component';
import { BroadcastService, MsalService } from '@azure/msal-angular';


@Component({
  selector: 'app-offboarding',
  templateUrl: './check-offboarding.component.html',
  styleUrls: ['./check-offboarding.component.css']
})
export class CheckOffBoardingComponent extends BaseAutorizeComponent {
  
  errorMessage: string;
  submitted: boolean = false;
  working: boolean = true;
  status: string;

  constructor(broadcastService: BroadcastService, authService: MsalService, private functionsService: AzureFunctionsService) { 
    super(broadcastService, authService)
  }

  onInitChild() {
    this.refresh();   
  }

  refresh(){
    this.errorMessage = null;
    this.working = true;
    this.functionsService.getOffboardingStatus().then((status) => {
      this.working = false;
       this.status = status;
      },
      (e) => {
        this.errorMessage = e.error || e.message;
        this.working = false;
      });
  }
}
